import { FC, useRef } from 'react';
import { SearchErrorBoundary, SearchFallbackBoundary, SearchHits, SearchInput } from '@belong/search';
import { SEARCH_TEST_IDS } from '@belong/search/src/test/utils/testIds';
import { FONT_COLOURS } from '@belong/themes';
import { Column, Columns, Display, Section, Stack } from '@belong/ui-components';
import { SearchGenericError } from './error';
import { EmptyQueryFallback, NoResultsFallback } from './fallbacks';

interface ISectionSearchResults {
  title: string;
  showResults?: boolean;
}

const SectionSearchResults: FC<ISectionSearchResults> = ({ title, showResults = true }) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Section hasBackground="black" hasPaddingBottom hasPaddingTop data-testid="section-search-results">
        <Stack space="xlarge">
          <Display alignment="center" as="h1" hasColor={FONT_COLOURS.LIGHT} id="search-title">
            {title}
          </Display>
          <Columns alignX="center">
            <Column width={{ xs: '1', lg: '3/4', xl: '1/2' }}>
              <SearchInput
                searchInputRef={searchInputRef}
                searchOnRedirect={!showResults}
                data-testid={`section-search-results-${SEARCH_TEST_IDS.INPUT_ROOT}`}
              />
            </Column>
          </Columns>
        </Stack>
      </Section>
      {showResults && (
        <SearchErrorBoundary ErrorComponent={SearchGenericError} searchInputRef={searchInputRef}>
          <SearchFallbackBoundary EmptyQueryFallback={EmptyQueryFallback} NoResultsFallback={NoResultsFallback}>
            <Section hasPaddingBottom hasPaddingTop>
              <Columns alignX="center">
                <Column width={{ xs: '1', lg: '3/4', xl: '1/2' }}>
                  <SearchHits />
                </Column>
              </Columns>
            </Section>
          </SearchFallbackBoundary>
        </SearchErrorBoundary>
      )}
    </>
  );
};

export default SectionSearchResults;
